module.exports = __webpack_public_path__ + "static/media/secietypic02.82ea7a27.png";